/**
 * Block auto spacing
 */

var $ = jQuery;

$(document).ready(function() {

    /**
     * Helper function for matching block classes
     */ 
    $.fn.hasClassRegEx = function(regex) {
        let classes = $(this).attr('class');

        if (!classes || !regex) { 
            return false; 
        }

        classes = classes.split(' ');
        let len = classes.length;

        for (let i=0; i<len; i++) {
            if (classes[i].match(regex)) { 
                return true; 
            }
        }

        return false;
    };    

    /**
     * First block in content auto margin top
     */
    /*let first = $('.page-content > *, .article-content > *').first();

    if (first.length && !first.hasClass('block')) {
        first.addClass('mt-5 mt-xxl-6');
    }*/

    /**
     * Last block in content auto margin bottom
     */
    /*let last = $('.page-content > *, .article-content > *').last();

    if (last.length && !last.hasClass('block')) {
        last.addClass('mb-5 mb-xxl-6');
    }*/

    /**
     * Spacing default blocks with custom ones
     */
    $('.page-content > *:not(.block), .article-content > *:not(.block)').each(function() {

        let next = $(this).next();

        if (next.length && next.hasClass('block') && !next.hasClassRegEx(/bg-/)) {
            $(this).css('margin-bottom', 0);
        }

        let prev = $(this).prev();

        if (prev.length && prev.hasClass('block') && !prev.hasClassRegEx(/bg-/)) {
            $(this).css('margin-top', 0);
        }

    });

    /**
     * Custom block auto spacing 
     */
    $('.block').each(function() { // custom block class

        try {

            let blockClasses = $(this).attr('class');
            let prev         = $(this).prev();

            if (
                prev.length 
                && !prev.hasClass('block-offset') 
                && !$(this).hasClass('block-offset') 
                && !$(prev).css('background-image') == 'none' 
                && $(this).css('background-image') == 'none' 
               ) 
            {

                let blockBgClass = blockClasses.match(/(\sbg-\S+)/ig);

                if (blockBgClass != null) { // if has bg class

                    /** 
                     * Remove padding bottom from blocks previous to this block 
                     * if they have same background color
                     */    

                    blockBgClass    = blockBgClass.toString();
                    let prevClasses = prev.attr("class").toString();

                    if (prevClasses.length && prevClasses.indexOf(blockBgClass) >= 0) {
                        prev.attr('style', function(i,s) { return (s || '') + 'padding-bottom: 0 !important;' });
                    }

                } else { // if does not have bg class

                    if (prev.hasClass('block') && !prev.hasClassRegEx(/bg-/)) {
                        prev.attr('style', function(i,s) { return (s || '') + 'padding-bottom: 0 !important;' });
                    }

                }

            }

        } catch (error) {

            // debug
            // console.error(error);

        }

    });


    $('.textbox-vertical-align-center').each(function() {
        var margintop = 0;
        var visibleheight = 0;
        $(this).children().each(function(){
            if ($(this).css('max-height')!=0) visibleheight += $(this).height();
        
        });
        margintop = (visibleheight / 2) - 20;
        $(this).css('margin-top', margintop+'px');
    });
});
